<input [placeholder]="placeholder" [readOnly]="readOnly"
       [owlDateTimeTrigger]="dt" [owlDateTime]="dt" [(ngModel)]="value">
<owl-date-time #dt></owl-date-time>